import { render } from "./MLEsTable.vue?vue&type=template&id=53140c2b"
import script from "./MLEsTable.vue?vue&type=script&lang=js"
export * from "./MLEsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__